import { getKeys } from './getKeys'

export const reportsTranslations = {
  BEDS_OCCUPIED: '{{occupied}} out of {{total}} beds occupied',
  title: 'Occupancy',
  founding: 'Funding',
  foundingSub: 'Your current active {{variable}} shown by type of funding',
  currentOccupancy: 'Current occupancy',
  currentOccupancySub:
    'Your current bed occupancy based on the number of active {{variable}}',
  3: 'Change Over Time',
  overtimeSub: 'Number of {{variable}} displayed over time',
  emptyTitle: 'Start tracking occupancy insights and trends!',
  emptyDesc:
    'The number of beds and service user data will allow you to better understanding the occupancy of your services at the moment and over time.',
  btnTitle: 'Set up Bed Capacity',
}

export const reportsConstants = getKeys(reportsTranslations)
